import React from "react";

const CsvIcon = ({ color = "#595959" }) => {
    return (
        <>
            <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M4.79102 12.4997H7.29102V11.2497H5.20768V8.74967H7.29102V7.49967H4.79102C4.5549 7.49967 4.35713 7.57967 4.19768 7.73967C4.03824 7.89967 3.95824 8.09745 3.95768 8.33301V11.6663C3.95768 11.9025 4.03768 12.1005 4.19768 12.2605C4.35768 12.4205 4.55546 12.5002 4.79102 12.4997ZM8.04102 12.4997H10.541C10.7771 12.4997 10.9752 12.4197 11.1352 12.2597C11.2952 12.0997 11.3749 11.9019 11.3743 11.6663V10.4163C11.3743 10.1802 11.2943 9.96134 11.1343 9.75967C10.9743 9.55801 10.7766 9.45745 10.541 9.45801H9.29102V8.74967H11.3743V7.49967H8.87435C8.63824 7.49967 8.44046 7.57967 8.28102 7.73967C8.12157 7.89967 8.04157 8.09745 8.04102 8.33301V9.58301C8.04102 9.81912 8.12102 10.0311 8.28102 10.2188C8.44102 10.4066 8.63879 10.5002 8.87435 10.4997H10.1243V11.2497H8.04102V12.4997ZM13.541 12.4997H14.791L16.2493 7.49967H14.9993L14.166 10.3747L13.3327 7.49967H12.0827L13.541 12.4997ZM3.33268 16.6663C2.87435 16.6663 2.48213 16.5033 2.15602 16.1772C1.8299 15.8511 1.66657 15.4586 1.66602 14.9997V4.99967C1.66602 4.54134 1.82935 4.14912 2.15602 3.82301C2.48268 3.4969 2.8749 3.33356 3.33268 3.33301H16.666C17.1243 3.33301 17.5168 3.49634 17.8435 3.82301C18.1702 4.14967 18.3332 4.5419 18.3327 4.99967V14.9997C18.3327 15.458 18.1696 15.8505 17.8435 16.1772C17.5174 16.5038 17.1249 16.6669 16.666 16.6663H3.33268Z"
                    fill={color}
                />
            </svg>
        </>
    );
};

export default CsvIcon;
